module.exports = __webpack_public_path__ + "img/banner-font.0976e07c.png";